import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface ItemPhoto {
    itemTypeOptions: GenericListItem[];
    itemTypeId: number;
    uploadedFiles: File[];
    loading: boolean;
    errors: any;
}

interface GenericListItem {
    id: number;
    name: string;
}

export class ItemPhotoData extends React.Component<RouteComponentProps<{}>, ItemPhoto> {
    constructor(props: any) {
        super(props);

        this.state = {
            itemTypeOptions: [],
            itemTypeId: -1,
            uploadedFiles: [],
            loading: true,
            errors: {}
        };

    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();
        axios.get('api/User/CheckUserPermission?Permission=CreateEditAdminLists&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
            .then(res => {
                if (res.data == true) {
                    axios.get('api/Admin/GetItemTypes', {
                        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                    })
                        .then(res => {
                            this.setState({ itemTypeOptions: res.data, loading: false });
                        })
                        .catch(error => {
                            toast.error(error.message);
                        });
                } else if (res.data == false) {
                    //redirect to 403 permission denied
                    this.props.history.push("/accessdenied")
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let change: any = {};
        change[e.target.name] = e.target.value;
        change["errors"] = errors;
        this.setState(change)
    }

    handleImportFile = (e: any) => {
        this.setState({ uploadedFiles: e.target.files });
    }

    importPhotos = () => {
        let errors: any = {};

        if (this.state.itemTypeId < 0) {
            errors["itemTypeId"] = "Item Type is Required!";
            this.setState({ errors: errors });
        } else {
            this.importJobPhotos();
        }
    }

    async importJobPhotos() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var uploadedFile = this.state.uploadedFiles[0];

        //save photos
        const data = new FormData()
        data.append('ItemTypeId', this.state.itemTypeId.toString());
        data.append('subId', user.sub);
        data.append('photo', uploadedFile);

        //save photos
        axios.post('api/Admin/SaveItemPhoto', data, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Photo has been uploaded");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            <h1>Item Formulas</h1>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let itemTypeOptions = this.state.itemTypeOptions;

        return (
            <div>
                <label className="input-group" htmlFor="contact">
                    <span className="label">Item Type</span>
                    <select className="select" id="itemTypeId" name="itemTypeId" value={this.state.itemTypeId} onChange={(e) => this.handleChange(e)}>
                        <option hidden defaultValue="-1"></option>
                        {itemTypeOptions.map(item =>
                            <option key={item.id} value={item.id}>{item.name}</option>
                        )};
                    </select>
                </label>
                <span className="label errors">{this.state.errors["itemTypeId"]}</span>

                <div className="marginTop10">
                    <input type="file" name="file" accept="image/*" onChange={this.handleImportFile} />
                </div>

                <button className="defaultbutton" type="button" onClick={this.importPhotos}>Save</button>
            </div>
        );
    }
}